<template>
    <div class="position-relative dropdown border-default" ref="" id="dropdown-container" @click="$emit('click')">
        <div class="position-absolute left-0 d-flex align-items-center">
            <slot name="icon-left"></slot>
        </div>
        <input
            class="text-elipsis border-0 outline-none cursor-pointer text-grey-900"
            style="background-color: white;"
            :class="{
                'subcaption-strong': hasValue,
                caption: !hasValue
            }"
            :id="dataId"
            :value="displayValue"
            spellcheck="false"
            autocomplete="off"
            @input="(e) => onInput(e.target.value)"
            @keyup="$emit('keyup', $event)"
            @focus="onFocus"
            @blur="onBlur"
            ref="input"
        />
        <!-- <div
            class="position-absolute top-50pc right-0 align-items-center mr-2 font-22 cursor-pointer translate-t-n50pc"
            :class="{
                'd-flex': hasValue,
                'd-none': !hasValue
            }"
            @click="$emit('clear')"
        >
            <FontAwesomeIcon icon="fa-regular fa-circle-xmark" />
        </div> -->
        <div class="position-absolute top-50pc right-0 align-items-center mr-2 translate-t-n50pc">
            <slot name="icon-right"></slot>
        </div>
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons'

library.add(faCircleXmark, faCaretDown)

export default {
    name: 'DropdownInputHeader',
    components: {
        FontAwesomeIcon
    },
    props: {
        events: Object,
        hasValue: Boolean,
        placeholder: String,
        label: String,
        dataId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            data: {
                value: ''
            },
            off: [],
            state: {
                focused: false
            }
        }
    },
    computed: {
        displayValue() {
            return this.state.focused ? this.data.value : this.label || this.placeholder
        }
    },
    methods: {
        onInput(value) {
            this.data.value = value
            this.$emit('input', value)
        },
        onFocus(e) {
            this.state.focused = true
            this.data.value = ''
            this.$emit('openDropdown', e)
        },
        onBlur() {
            this.state.focused = false
            this.data.value = ''
            // this.$emit('closeDropdown')
        }
    },
    beforeDestroy() {
        this.off.forEach((off) => off())
    },
    mounted() {
        if (this.events) {
            this.off.push(
                this.events.on('filter', (filter) => {
                    this.data.value = filter
                }).off,
                this.events.on('blur', () => {
                    this.data.value = ''
                    this.$refs.input.blur()
                }).off
            )
        }
    }
}
</script>

<style scoped>
input {
    width: 100%;
}
</style>
